interface ApiConfig {
    apiUrl: string;
    auth0: {
      domain: string;
      clientId: string;
      audience: string;
    };
  }

  
  const getConfig = (): ApiConfig => {
    // Determine environment based on hostname. The `dev` stack label can be the
    // leftmost label on the old-stack host (`dev.fortius-app.com`) OR a middle
    // label on a new-stack tenant host (`charingcross.dev.lon.fortius-app.com`),
    // so match `dev` as a whole dot-delimited label, not just a prefix.
    // Missing this routed dev tenant hosts to the prod API + prod Auth0 client id
    // (the FORT-219 misconfiguration path) when REACT_APP_* were unset.
    const hostname = window.location.hostname;
    const isDev = /(^|\.)dev\./.test(hostname);
    
    // Use environment variables first (from Amplify), then fallback to environment-based defaults
    return {
      apiUrl: process.env.REACT_APP_CLUBBOOKING_API_URL || 
             (isDev ? 'https://api-dev.fortius-app.com' : 'https://api.fortius-app.com'),
      auth0: {
        domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
        // Single shared Auth0 application across both the legacy and the new
        // multi-tenant stack. FORT-219 settled on ONE app: the two stacks are
        // told apart by the signup redirect_uri host (see the add-fortius-user
        // action's new-stack-host guard), NOT by the client_id. Prefer the env
        // var (set per-environment in Amplify); fall back to the shared SPA
        // client id in every environment. (It's a public SPA id, not a secret.)
        clientId: process.env.REACT_APP_AUTH0_CLIENT_ID ||
                 'PObxgST19jnsaF6FkBthOeQaN5ZZH3DR',
        audience: process.env.REACT_APP_AUTH0_AUDIENCE ||
                 (isDev ? 'https://api-dev.fortius-app.com' : 'https://api.fortius-app.com')
      }
    };
  };

  export const apiConfig = getConfig();
